import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DigitalCourseService } from 'src/app/services/digital-course.service';

@Component({
  selector: 'cm-digital-course-detail',
  templateUrl: './digital-course-detail.component.html',
  styleUrls: ['./digital-course-detail.component.scss']
})
export class DigitalCourseDetailComponent implements OnInit {
  slug: string;
  course;
  paymentTypes: any[] = [];
  banner = '';

  constructor(
    private _router: ActivatedRoute,
    private _DigitalCourseService: DigitalCourseService
    
  ) { }

  ngOnInit() {
    const slug = this._router.snapshot.paramMap.get('slug');
    this.course = this._DigitalCourseService.getCourseBySlug(slug!);

    this._getBanner();
  }

  private _getBanner(): void {
    this.banner = 'https://hne-s3.s3.us-east-2.amazonaws.com/banner/0048282025031867d8ed0c6fc20.png';
  }
}
